import ModuleHeader from "../components/ModuleHeader/ModuleHeader";
import usePrivateLink from "../config/usePrivateLink";

const tabs = [
  {
    id: "BanksAccountCreate",
    title: "Bank Account Add",
    icon: "ri-bank-line",
    path: "/account/bank/add",
  },
  {
    id: "BanksAccountList",
    title: "Bank Account List",
    icon: "ri-list-check",
    path: "/settings/bank",
    activePaths: ["/settings/bank", "/settings/bank/transactions/:id"],
  },
  {
    id: "Fund Transfer",
    title: "Fund Transfer Transaction",
    icon: "ri-history-line",
    path: "/settings/bank/fund/transfer",
  },
];

export default function BankLayout({ children }) {
  return;
  const hasAccess = usePrivateLink();

  const visibleTabs = tabs.filter((tab) => hasAccess(tab.path));

  return (
    <>
      <ModuleHeader tabs={visibleTabs} />
      {children}
    </>
  );
}
